<template>
  <section>
    <div class="section flex flex-col">
      <transition appear @before-enter="beforeEnterH1" @enter="enterH1">
        <h1>{{ "" }}</h1>
      </transition>
      <transition appear @before-enter="beforeEnter" @enter="enter">
        <p class="error">{{ error }}</p>
      </transition>
    </div>
  </section>
</template>

<script>
import gsapAnimation from "../../composables/gsapAnimation";
export default {
  props: {
    error: String,
    beforeEnter: Function,
    enter: Function,
  },
  setup() {
    let { beforeEnterH1, enterH1 } = gsapAnimation({
      h1: "Error",
    });
    return {
      beforeEnterH1,
      enterH1,
    };
  },
};
</script>
